module.exports = __webpack_public_path__ + "img/logo_cei_louvain.ada6837d.png";